import { combineReducers } from 'redux';
import { ClaimDetails, ClaimsDetailsInitialState } from './models/claimListModel';
import claimDetailReducer from './reducers/claimListReducer';
import claimDetailInitialReducer from './reducers/claimDetailReducer';
import { DashboardState } from './models/dashboardModel';
import { ClaimsDetails } from './models/claimDetailModel';
import claimReducer from './reducers/claimReducer';
import dashboardReducer from './reducers/dashboardReducer';

export interface RootState {
    claimDetails: ClaimDetails;
    claimsDetailsInitialState: ClaimsDetailsInitialState;
    claimsDetails: ClaimsDetails;
    dashboard: DashboardState;
}

export const rootReducer =
combineReducers({
    claimDetails: claimDetailReducer,
    claimsDetailsInitialState: claimDetailInitialReducer,
    claimsDetails: claimReducer,
    dashboard: dashboardReducer,
});

export const rootReducerWithReset = (state: any, action: any) => {
    if (action.type === 'LOGOUT') {
        state = undefined;
    }
    return rootReducer(state, action);
}
